import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorAdditionalPaymentStep2FormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';

export const useAdditionalPaymentStep2FormFields = (intl: IntlShape) => {
  const AdditionalPaymentStep2FormFields: Record<
    keyof CalculatorAdditionalPaymentStep2FormFields,
    FormInput
  > = {
    additionalPayment: {
      fieldName: 'additionalPayment',
      label: intl.formatMessage({
        id: 'step2.additionalPayment',
        defaultMessage: 'Extra aflossing'
      }),
      type: 'currency',
      required: true,
      removeDecimals: true,
      placeHolder: '€ 200',
      defaultValue: getDefaultValue('200')
    },
    paymentType: {
      fieldName: 'paymentType',
      label: intl.formatMessage({
        id: 'step2.paymentType',
        defaultMessage: 'Op welk hypotheekdeel aflossen'
      }),
      type: 'select',
      tooltip: intl.formatMessage({
        id: 'step2.paymentType.tooltip',
        defaultMessage:
          'Op welk hypotheekdeel wilt u aflossen?\n' +
          'Als u deze keuze heeft, voer de berekening dan uit voor beiden opties en vergelijk het verschil. U ziet dan welke optie welk voordeel heeft: lagere maandlasten, een lagere restschuld en/of lagere totale rentekosten. Mogelijk kunt u de aflossing ook verdelen tussen beide delen.'
      }),
      options: [
        {
          label: intl.formatMessage({
            id: 'step2.paymentType.option.annuiteitenLineair',
            defaultMessage: 'Annuïtair / lineair'
          }),
          value: 'hfd'
        },
        {
          label: intl.formatMessage({
            id: 'step2.paymentType.option.aflossingsvrij',
            defaultMessage: 'Aflossingsvrij'
          }),
          value: 'afl'
        }
      ],
      required: true,
      defaultValue: getDefaultValue('hfd', true)
    }
  };
  return AdditionalPaymentStep2FormFields;
};
